/**
 * Created by rhampton on 7/11/2014.
 */
angular.module('services.bulkFuelPriceNotices', ['core.ajax']);

angular.module('services.bulkFuelPriceNotices',[]).service('bulkFuelPriceNoticesService', function($q, apiService) {
    'use strict';
    return {
        loadBulkFuelPrices: function(custKey, custLocKey, startDate, endDate) {
            var deferred = $q.defer();
            var apiSvcSettings = new ApiServiceSettings(
                {
                    method: 'POST',
                    url: '../api/GetBulkFuelPriceNotices/',
                    data: {
                        CustKey:custKey,
                        CustLocKey:custLocKey,
                        StartDate:startDate,
                        EndDate:endDate
                    }
                }
            );
            apiService.execute(apiSvcSettings).then(
                function (data) {
                    deferred.resolve(data.Data);
                }
            );
            return deferred.promise;
        }
    };
});